/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiCreateServiceRequest, ApiService, LockElement, LockedContextDto } from '@Model';
import type { HttpActions, ListInfo, ListRequest, ListRequestWithIds, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of ServicesController.
 */
export class ServicesRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls GET /services/{serviceId}/weight
     */
    public getWeightFromQuantity(serviceId: string, amount: number): Promise<Result<number>> {
        const query = new URLSearchParams();
        query.set('amount', `${amount}`);

        return this.http.get<Result<number>>(`/services/${serviceId}/weight`, query);
    }

    /**
     * Calls GET /services/{serviceId}/quantity
     */
    public getQuantityFromWeight(serviceId: string, weight: number): Promise<Result<number>> {
        const query = new URLSearchParams();
        query.set('weight', `${weight}`);

        return this.http.get<Result<number>>(`/services/${serviceId}/quantity`, query);
    }

    /**
     * Calls POST /services:prefill
     */
    public createPrefilledService(apiCreateServiceRequest: ApiCreateServiceRequest | undefined): Promise<Result<ApiService>> {
        return this.http.post<Result<ApiService>, ApiCreateServiceRequest | undefined>('/services:prefill', apiCreateServiceRequest);
    }

    /**
     * Calls GET /services/{primaryId}
     */
    public get(primaryId: string, include: string | undefined): Promise<Result<ApiService>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ApiService>>(`/services/${primaryId}`, query);
    }

    /**
     * Calls POST /services:batch
     */
    public getBatch(listRequest: ListRequestWithIds, include: string | undefined): Promise<Result<ListInfo<ApiService>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiService>>, ListRequestWithIds>('/services:batch', listRequest, query);
    }

    /**
     * Calls POST /services:query
     */
    public getListPost(listRequest: ListRequest, include: string | undefined): Promise<Result<ListInfo<ApiService>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiService>>, ListRequest>('/services:query', listRequest, query);
    }

    /**
     * Calls POST /services
     */
    public add(dto: ApiService): Promise<Result<ApiService>> {
        return this.http.post<Result<ApiService>, ApiService>('/services', dto);
    }

    /**
     * Calls PUT /services/{primaryId}
     */
    public update(dto: ApiService, primaryId: string): Promise<Result<ApiService>> {
        return this.http.put<Result<ApiService>, ApiService>(`/services/${primaryId}`, dto);
    }

    /**
     * Calls PATCH /services
     */
    public putRange(dtos: ApiService[]): Promise<Result<ApiService[]>> {
        return this.http.patch<Result<ApiService[]>, ApiService[]>('/services', dtos);
    }

    /**
     * Calls DELETE /services/{primaryId}
     */
    public delete(primaryId: string): Promise<Result<boolean>> {
        return this.http.delete<Result<boolean>>(`/services/${primaryId}`);
    }

    /**
     * Calls POST /services/{draftId}/commit
     */
    public commitDraft(draftId: string): Promise<Result<ApiService>> {
        return this.http.post<Result<ApiService>, undefined>(`/services/${draftId}/commit`, undefined);
    }

    /**
     * Calls POST /services/{primaryId}/start_edit_mode
     */
    public startEditMode(primaryId: string): Promise<Result<LockedContextDto<ApiService>>> {
        return this.http.post<Result<LockedContextDto<ApiService>>, undefined>(`/services/${primaryId}/start_edit_mode`, undefined);
    }

    /**
     * Calls POST /services/locks
     */
    public lockAll(ids: string[]): Promise<Result<ApiService[]>> {
        return this.http.post<Result<ApiService[]>, string[]>('/services/locks', ids);
    }

    /**
     * Calls POST /services/{primaryId}/locks
     */
    public lock(primaryId: string): Promise<Result<LockElement>> {
        return this.http.post<Result<LockElement>, undefined>(`/services/${primaryId}/locks`, undefined);
    }

    /**
     * Calls DELETE /services/{primaryId}/locks
     */
    public unlock(primaryId: string): Promise<Result<boolean>> {
        return this.http.delete<Result<boolean>>(`/services/${primaryId}/locks`);
    }

    /**
     * Calls GET /services:query
     */
    public getListGet(pageNo: number, pageSize: number, include: string | undefined): Promise<Result<ListInfo<ApiService>>> {
        const query = new URLSearchParams();
        query.set('pageNo', `${pageNo}`);
        query.set('pageSize', `${pageSize}`);
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ListInfo<ApiService>>>('/services:query', query);
    }
}
